<template>
  <div v-if="holidayEntity">
    <h1>
      Holidays for
      {{full}}
    </h1>
    <EntityWorking v-if="entity" :entity="entity" />
    <v-card v-if="!entity">
      <v-card-text>Public holidays</v-card-text>
    </v-card>
    <div>
      <a @click="changeYear(holidayEntity.previousYear)">{{holidayEntity.previousYear}}</a>
      <span>&#160;</span>
      <span class="holidayYear">{{holidayEntity.year}}</span>
      <span>&#160;</span>
      <a @click="changeYear(holidayEntity.nextYear)">{{holidayEntity.nextYear}}</a>
    </div>
    <v-alert
      :value="$keycloak.hasRealmRole('holidayadmin')"
      type="info"
    >To make changes please select the holidays below that you wish to change. Then select from the box the action you wish to take and click update.</v-alert>
    <template v-if="$keycloak.hasRealmRole('holidayadmin')">
      <v-btn :to="{name:'holidayCalendar'}">
        <v-icon>chevron_left</v-icon>Calendar
      </v-btn>
      <v-btn :to="computedHolidayAddLink" color="success" small>
        <v-icon>add</v-icon>Holiday
      </v-btn>
      <v-select
        label="Action"
        v-model="actionId"
        :items="actions"
        item-value="id"
        item-text="text"
        outline
      >
        <template slot="append-outer" v-if="actionId != 0">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn @click="saveHolidays" v-on="on" color="success">
                <v-icon>double_arrow</v-icon>Update
              </v-btn>
            </template>
            <span>Apply chosen action to holidays selected below</span>
          </v-tooltip>
        </template>
      </v-select>
    </template>
    <div
      v-for="holidayEntityMonth in computedHolidayEntity.holidayEntityMonths"
      :key="holidayEntityMonth.id"
    >
      <h2>{{holidayEntityMonth.name}}</h2>
      <table border="1">
        <tr>
          <th>Selected</th>
          <th>Day</th>
          <th>Weekday</th>
          <th>Portion</th>
          <th>Created by</th>
          <th>Created</th>
        </tr>
        <tr v-for="holiday in holidayEntityMonth.holidays" :key="holiday.id">
          <td>
            <v-checkbox
              v-model="holidayids"
              :value="holiday.id"
              v-if="$keycloak.hasRealmRole('holidayadmin')"
            />
          </td>
          <td>{{holiday.date | formatDay}}</td>
          <td>{{holiday.date | formatWeekday}}</td>
          <td>
            <span v-if="holiday.morning && !holiday.afternoon" class="holidayCalendarHalf">Morning</span>
            <span v-if="!holiday.morning && holiday.afternoon" class="holidayCalendarHalf">Afternoon</span>
            <span v-if="holiday.morning && holiday.afternoon" class="holidayCalendarHalf">Full</span>
          </td>
          <td>
            <EntityZ :entity="holiday.entity" format="system" v-if="holiday.entity" />
          </td>
          <td>{{holiday.timestamp | formatDateTime}}</td>
        </tr>
      </table>
    </div>
    <p>
      <span>{{holidayEntity.total}}</span>
      <span>&#160;</span>
      <span>days</span>
    </p>
    <v-dialog v-model="updatingHolidays" persistent width="300">
      <v-card color="error" dark>
        <v-card-text>
          <span>Please wait while server updates holidays</span>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EntityWorking from "@/components/link/EntityWorking";
import EntityZ from "@/components/link/EntityZ";
import nbmlaw from "@/api/nbmlaw";
import { nameFormatted } from "@/util/helpers";
function initialState() {
  return {
    // year:null,
    entity: null,
    holidays: null,
    holidayids: [],
    holidayEntity: null,
    holidaysEntities: null,
    headers: [
      {
        text: "Selected",
        sortable: false
      },
      {
        text: "Day",
        sortable: false
      },
      {
        text: "Weekday",
        sortable: false
      },
      {
        text: "Portion",
        sortable: false
      },
      {
        text: "Created by",
        sortable: false
      },
      {
        text: "Created",
        value: "timestamp"
      }
    ],
    pagination: {
      sortBy: "date",
      rowsPerPage: -1
    },
    actions: [
      { id: 0, text: "Not set" },
      { id: 1, text: "Delete" },
      { id: 2, text: "Full day" },
      { id: 3, text: "Morning" },
      { id: 4, text: "Afternoon" }
    ],
    actionId: 0,
    updatingHolidays: false
  };
}
export default {
  name: "HolidayEntity",
  metaInfo() {
    return {
      title: "Holiday entity",
      titleTemplate: "%s - Directory - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { EntityWorking, EntityZ },
  computed: {
    full() {
      return this.entity
        ? nameFormatted(this.entity.name, "full")
        : "Public holidays";
    },
    computedHolidayEntity() {
      if (!this.holidayEntity) {
        return undefined;
      }
      const holidayEntityMonths = this.holidayEntity.holidayEntityMonths.map(
        m => {
          const holidays = m.holidayids.map(h => {
            const holiday = this.holidays ? this.holidays[h] : undefined;
            const entity =
              holiday && this.holidaysEntities
                ? this.holidaysEntities[holiday.userid]
                : undefined;
            return { ...holiday, entity };
          });
          return { ...m, holidays };
        }
      );
      const holidayEntity = { ...this.holidayEntity, holidayEntityMonths };
      // console.log(holidayEntity);
      return holidayEntity;
    },
    computedHeaders() {
      return this.headers.filter(
        h =>
          !(
            !this.$keycloak.hasRealmRole("holidayadmin") && h.text == "Selected"
          )
      );
    },
    computedHolidayAddLink() {
      const id = this.entity ? this.entity.id : undefined;
      return { name: "holidayAdd", query: { id } };
    }
  },
  data: function() {
    return initialState();
  },
  methods: {
    fetchEntity() {
      nbmlaw
        .get(`/cors/admin/directory/entities/${this.$route.params.id}`)
        .then(response => {
          // console.log(response.data);
          this.entity = response.data;
          if (!this.entity) {
            this.$router.push({
              name: "pageNotFound"
            });
          }
        })
        .catch(() => {});
    },
    fetchHolidaysMonth() {
      nbmlaw
        .get(
          `/cors/admin/directory/entities/${this.$route.params.id}/holidays/month`,
          {
            params: { year: this.$route.query.year }
          }
        )
        .then(response => {
          // console.log(response.data);
          this.holidayEntity = response.data;
        })
        .catch(() => {});
    },
    fetchHolidays() {
      nbmlaw
        .get(
          `/cors/admin/directory/entities/${this.$route.params.id}/holidays`,
          {
            params: { year: this.$route.query.year }
          }
        )
        .then(response => {
          // console.log(response.data);
          this.holidays = response.data;
        })
        .catch(() => {});
    },
    fetchHolidaysUsers() {
      nbmlaw
        .get(
          `/cors/admin/directory/entities/${this.$route.params.id}/holidays/users`,
          {
            params: { year: this.$route.query.year }
          }
        )
        .then(response => {
          // console.log(response.data);
          this.holidaysEntities = response.data;
        })
        .catch(() => {});
    },
    fetchHolidaysPublicMonth() {
      nbmlaw
        .get(`/cors/admin/directory/holidays/public/month`, {
          params: { year: this.$route.query.year }
        })
        .then(response => {
          // console.log(response.data);
          this.holidayEntity = response.data;
        })
        .catch(() => {});
    },
    fetchHolidaysPublic() {
      nbmlaw
        .get(`/cors/admin/directory/holidays/public`, {
          params: { year: this.$route.query.year }
        })
        .then(response => {
          // console.log(response.data);
          this.holidays = response.data;
        })
        .catch(() => {});
    },
    fetchHolidaysPublicUsers() {
      nbmlaw
        .get(`/cors/admin/directory/holidays/public/users`, {
          params: { year: this.$route.query.year }
        })
        .then(response => {
          // console.log(response.data);
          this.holidaysEntities = response.data;
        })
        .catch(() => {});
    },
    changeYear(year) {
      if (this.$route.params.id) {
        this.$router.push({
          name: "holidayEntity",
          params: { id: this.$route.params.id },
          query: { year }
        });
      } else {
        this.$router.push({
          name: "holidayEntityPublicHoliday",
          query: { year }
        });
      }
    },
    saveHolidays() {
      this.updatingHolidays = true;
      // console.log(this.holidayids);
      nbmlaw
        .put(`/cors/admin/directory/holidays/${this.actionId}`, this.holidayids)
        .then(() => {
          // console.log(response.data);
          this.update();
        })
        .catch(() => {});
      this.updatingHolidays = false;
    },
    update() {
      Object.assign(this.$data, initialState());
      if (this.$route.params.id) {
        this.fetchEntity();
        this.fetchHolidays();
        this.fetchHolidaysMonth();
        this.fetchHolidaysUsers();
      } else {
        this.fetchHolidaysPublic();
        this.fetchHolidaysPublicMonth();
        this.fetchHolidaysPublicUsers();
      }
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.update();
      }
    },
    "$route.query.year": {
      immediate: true,
      handler() {
        this.update();
      }
    }
  }
};
</script>

<style scoped>
.holidayCalendarHalf {
  color: green;
}

.holidayYear {
  font-size: 1.5em;
  font-weight: bold;
}
</style>